import { Injector } from '@angular/core';
import { IEffect } from '../modules/dynamic-effects/effect.interface';
import { Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { Actions } from '@ngrx/effects';
import { EffectsRegistrationService } from '../modules/dynamic-effects/effects-registration.service';
import { JobsiteRadiusRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-render-map-effects/jobsite-radius-render-map.effects';
import {
  AddressesService,
  CalendarsService,
  CatalogsService,
  ContactService,
  ContractBalanceService,
  DestinationsService,
  DraftService,
  HaulersService,
  HolidaysService,
  JobsiteBlockedService,
  JobsiteCommercialChannelService,
  JobsiteSalesAreasService,
  NextWorkingDayService,
  OpportunityService,
  OrdersService,
  PaymentTermService,
  PlantsService,
  PointOfDeliverySalesAreasService,
  ProductService,
  ProductsOpenPlatformService,
  PurchaseOrderService,
  SalesDocumentManagementService,
  ShipmentLocationsService,
  StdLotSizeService,
  TechnicalProductsOpenPlatformService,
  TimeWindowsService,
  VehiclesService,
} from '@cemex-core/cmx-api';
import { JobsiteLoadAddressEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-address-effects/jobsite-load-address.effects';
import { JobsiteLoadAddressModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-load-address.effects';
import { JobsiteLoadSalesAreaEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-address.effects';
import { JobsiteRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-render-map-effects/jobsite-render-map.effects';
import { JobsiteLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { JobsiteLoadLocSpecEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { JobsiteLoadAddressEffects as JobsiteLoadAddressLocSpecEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-load-address.effects';
import { RmsContractProductsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/contract-products.effects';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { Router } from '@angular/router';
import { AddedValuesNotFormulatingEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/added-values.effects-not-formulating';
import { AddedValuesNotFormulatingOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/addded-values.effects-not-formulating-op';
import { ExperiencesService } from '@cemex-core/cmx-api';
import { ExperiencesService as ExperiencesServiceInternal } from '@ordersnproducts/modules/shared/services/experiences.service';
import { CutOffEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/cut-off.effects';
import { SingleCatalogsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/single-catalogs.effects';
import { ReceivingPersonsLoadEffects } from '../modules/receiving-person/redux/effects/receiving-person-load.effects';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { JobsiteLoadModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';
import { JobsiteLoadModifyWithMaskEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-effects/jobsite-load-effects/jobsite-load-mask.effects';
import { ProductLoadEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/product-effects/product-load-effects/product-load.effects';
import { JobsiteLoadExperienceModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-load-experience.effects';
import { JobsiteLoaderService } from '@ordersnproducts/modules/order-builder/modules/location-specification/services/loaders/jobsite.loader.service';
import { ProductLoaderService } from '@ordersnproducts/modules/order-builder/modules/location-specification/services/loaders/product.loader.service';
import { ModifyOrderState } from '@ordersnproducts/modules/new-modify-order/reducers';
import { JobsiteLoadSalesAreasEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/jobsite-load-salesareas.effect';
import { PurchaseOrderMaskModifyEffects } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/effects/purchase-order-mask.effect';
import { SimulateEffects } from '@ordersnproducts/modules/order-builder/modules/rms-summary/effects/simulate.effects';
import { CmxClientService, CmxHttpClient } from '@cemex/cmx-client-layout';
import { TranslateService } from '@ngx-translate/core';
import { RmsOrderRequestSolverService } from '@ordersnproducts/modules/order-builder/modules/rms-summary/solvers/rms-order-request-solver.service';
import { PointOfDeliveryLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-effects/point-of-delivery-load.effects';
import { AddressService } from '@ordersnproducts/modules/shared/services/address.service';
import { AnalyticsTrackingService } from 'app/services/analytics-tracking.service';
import { PointOfDeliveryLoadAddressEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-address-effects/point-of-delivery-load-address.effects';
import { ReceivingPersonsCustomerLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/receiving-persons/receiving-person-load-effects/receiving-person-customer-load.effects';
import { JobsitePlantEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-plant-effects/jobsite-plant.effects';
import { JobsitePlantDefaultEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-plant-effects/jobsite-plant-default.effects';
import { PurchaseOrderRMSMandatoryEffects } from '@ordersnproducts/modules/new-repeat-order/modules/rms-top-location/effects/purchase-order-effects/purchase-order-mandatory.effects';
import { PurchaseOrderState } from '@ordersnproducts/modules/new-repeat-order/modules/rms-top-location/reducers/top-location-form.reducer';
import { AdtProductsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/products.effects';
import { AdtContractsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/contracts.effects';
import { AdtUnitsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/units.effects';
import { AdtPaymentTermsEffects } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/effects/paymet-terms.effects';
import { PurchaseOrderMandatoryEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/purchase-order-effects/purchase-order-mandatory.effects';
import { PointOfDeliveryLoadSalesAreaEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-sales-area/point-of-delivery-load-sales-area.effects';
import { PointOfDeliveryRadiusRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-render-map-effects/point-of-delivery-radius-render-map.effects';
import { PointOfDeliveryRenderMapEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-render-map-effects/point-of-delivery-render-map.effects';
import { PointOfDeliveryLoadAddressNewPODEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/point-of-delivery-effects/pod-load-address-effects/point-of-delivery-load-address-newpod.effects';
import { JobsiteLoadFullSalesAreaEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-full-sales-area.effects';
import { CalendarsEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/calendar-effects/calendars.effects';
import { JobsiteStdLotEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobiste-std-lot-effects/jobsite-std-lot.effects';
import { JobsiteLoadSalesAreaWithoutPlantEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-sales-area-without-plant.effects';
import { JobsiteWithoutDocumentsLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-effects/jobsite-load-without-documents.effects';
import { JobsiteNoShippingConditionLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/jobsite-effects/jobsite-load-effects/jobsite-load-no-shipping-condition.effects';
import { ExperiencesLoadEffect } from '@ordersnproducts/modules/order-builder/modules/location/effects/experiences-effects/experiences-load.effect';
import { UnitsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/units.effects';
import { AlternativeUnitsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/alternative-units.effects';
import { ContractEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract.effects';
import { ContractBalanceEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract-balance.effects';
import { NextWorkingDayEffect } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/effects/next-working-day.effects';
import { TimeWindowsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/time-windows.effects';
import { VehiclesEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/vehicle.effects';
import { ProductPlantsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/product-plants.effects';
import { V1OfmNextWorkingDayEffects } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/effects/v1-ofm-next-working-day.effects';
import {
  TopProductsEffects,
  TopProductsULinkEffects,
} from '@ordersnproducts/modules/order-builder/modules/retail-specification/effects/top-products.effects';
import { MinLotEffects } from '@ordersnproducts/modules/order-builder/modules/retail-specification/effects/min-lot.effects';
import { PaymentTermsEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/payment-terms.effects';
import { LoadHolidaysEffect } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/effects/load-holidays.effects';
import { HolidaysState } from '@ordersnproducts/modules/order-builder/modules/specification/reducers/specification/load-holidays.reducer';
import { SimulateOPEffects } from '@ordersnproducts/modules/order-builder/modules/rms-summary/effects/open-platform/simulate-op.effects';
import { ULOrderRequestSolverService } from '@ordersnproducts/modules/order-builder/modules/rms-summary/solvers/ul-order-request-solver.service';
import { AddedValuesOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/addded-values.effects';
import { TimeWindowsFromPlantLocationSpecificationEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/location-specification-form/time-windows-form-plant.effects';
import { PODLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/pod-load-effects/point-of-delivery-load.effects';
import { JobsiteLoadExperienceCompleteEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-load-experience-complete.effects';
import { JobsiteLoadExperienceEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/jobsite-load-experience.effects';
import { ProductExperienceLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/product-effects/product-load-effects/product-experience-load.effects';
import { ProductLoadEffects as ProductLoadLocSpecEffects } from '@ordersnproducts/modules/order-builder/modules/location-specification/effects/product-effects/product-load-effects/product-load.effects';
import { NewReceivingPersonEffects } from '../modules/receiving-person/redux/effects/new-receiving-person.effects';
import { ContactPersonApiService } from '@ordersnproducts/modules/order-builder/modules/location-specification/services/contact-person.api.service';
import { AnticipatedInvoiceLoadEffects } from '@ordersnproducts/modules/order-builder/modules/location/effects/anticipated-invoice-effects/anticipated-invoice-load-effects/anticipated-invoice-load.effects';
import { OneClickSalesAreaErrorEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-sales-area-error.effects';
import { OneCLickAlternativeUnitsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units.effects';
import { OneClickNextWorkingDayEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-next-working-day-services.effects';
import { OneClickHolidaysEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-holidays.effects';
import { OneClickOwnFreightPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-ownFreight-plants.effects';
import { OneClickHaulersEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-hauler.effect';
import { OneClickAdditionalServicesEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-additional-services.effects';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickContractEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-contract.effects';
import { OneClickReceivingPersonEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-receiving-person.effects';
import { OneClickStandardLotEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-standard-lot.effects';
import { State as LayoutState } from '@cemex/cmx-client-layout';
import { OneClickTimeWindowsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-time-windows.effects';
import { OneClickPaymentsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-payments.effects';
import { State as OneClickOrderState } from '@ordersnproducts/modules/one-click-order/reducers/index';
import { OneCLickAlternativeUnitsBuilderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units-builder.effects';
import { OneClickRegionPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-region-plants.effects';
import { OneClickPointOfDeliveriesEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-pods.effects';
import { OneClickPlantsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-plants.effects';
import { OneClickBuilderPaymentsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-payment-builder.effects';
import { OneClickProfileEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-profile.effects';
import { OneClickDraftService } from '@ordersnproducts/modules/one-click-order/services/one-click-draft.service';
import { OneClickJobsitesEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsites.effects';
import { RmsColombiaProductsEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/colombia-products.effects';
import { TimeWindowsFromPlantEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/time-windows-form-plant.effects';

export type factoryEffectFn = (injector: Injector) => IEffect;

export const JobsiteRadiusRenderMapFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const effectRegistrationService = injector.get(EffectsRegistrationService);
  return new JobsiteRadiusRenderMapEffects(actionsDep, storeDep, effectRegistrationService);
};

export const JobsiteLoadAddressFactory: factoryEffectFn = (injector: Injector) => {
  const addressesService = injector.get(AddressesService);
  const actionsDep = injector.get(Actions);
  return new JobsiteLoadAddressEffects(actionsDep, addressesService);
};

export const JobsiteLoadAddressLocSpecFactory: factoryEffectFn = (injector: Injector) => {
  const addressesService = injector.get(AddressesService);
  const actionsDep = injector.get(Actions);
  const effectRegistrationService = injector.get(EffectsRegistrationService);
  return new JobsiteLoadAddressLocSpecEffects(actionsDep, addressesService, effectRegistrationService);
};

export const JobsiteLoadAddressModifyFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const effectRegistrationService = injector.get(EffectsRegistrationService);
  const addressesService = injector.get(AddressesService);
  return new JobsiteLoadAddressModifyEffects(actionsDep, addressesService, effectRegistrationService);
};

export const JobsiteLoadSalesAreaFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const jobsiteSalesAreasService = injector.get(JobsiteSalesAreasService);
  const storeDep = injector.get(Store<OrderBuilderState>);
  return new JobsiteLoadSalesAreaEffects(actionsDep, jobsiteSalesAreasService, storeDep);
};

export const JobsiteRenderMapFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const effectRegistrationService = injector.get(EffectsRegistrationService);
  return new JobsiteRenderMapEffects(actionsDep, effectRegistrationService);
};

export const JobsiteLoadFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const shipmentLocationService = injector.get(ShipmentLocationsService);
  return new JobsiteLoadEffects(storeDep, actionsDep, shipmentLocationService);
};

export const RmsContractProductsFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const productService = injector.get(ProductService);
  return new RmsContractProductsEffects(actionsDep, storeDep, productService);
};

export const ProductsOpenPlatformFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const ProductsOpenPlatform = injector.get(ProductsOpenPlatformService);
  const productService = injector.get(ProductService);
  const router = injector.get(Router);
  return new ProductsOpenPlatformEffects(actionsDep, storeDep, ProductsOpenPlatform, productService, router);
};

export const AddedValuesNotFormulatingFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const productService = injector.get(ProductService);
  return new AddedValuesNotFormulatingEffects(actionsDep, storeDep, productService);
};

export const AddedValuesNotFormulatingOpenPlatformFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const technicalProductService = injector.get(TechnicalProductsOpenPlatformService);
  const experiencesService = injector.get(ExperiencesServiceInternal);

  return new AddedValuesNotFormulatingOpenPlatformEffects(
    actionsDep,
    storeDep,
    technicalProductService,
    experiencesService,
  );
};

export const CutOffFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const nextWorkingDayService = injector.get(NextWorkingDayService);

  return new CutOffEffects(actionsDep, storeDep, nextWorkingDayService);
};

export const SingleCatalogsFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const catalogService = injector.get(CatalogsService);
  const plantsService = injector.get(PlantsService);
  const router = injector.get(Router);

  return new SingleCatalogsEffects(actionsDep, storeDep, catalogService, plantsService, router);
};

export const ReceivingPersonsLoadFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const contactService = injector.get(ContactService);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const featureToggleService = injector.get(FeatureToggleService);
  const effectRegister = injector.get(EffectsRegistrationService);

  return new ReceivingPersonsLoadEffects(actionsDep, contactService, storeDep, featureToggleService, effectRegister);
};

export const JobsiteLoadModifyFactory = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const blockedJobsiteLoaderService = injector.get(JobsiteBlockedService);

  return new JobsiteLoadModifyEffects(storeDep, actionsDep, blockedJobsiteLoaderService);
};

export const JobsiteLoadModifyWithMaskFactory = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const blockedJobsiteLoaderService = injector.get(JobsiteBlockedService);
  return new JobsiteLoadModifyWithMaskEffects(storeDep, actionsDep, blockedJobsiteLoaderService);
};

export const ProductLoadFactory = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const ProductsOpenPlatform = injector.get(ProductsOpenPlatformService);

  return new ProductLoadEffects(storeDep, actionsDep, ProductsOpenPlatform);
};

export const JobsiteLoadExperienceModifyFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const experiencesService = injector.get(ExperiencesService);
  const storeDep = injector.get(Store<OrderBuilderState>);

  return new JobsiteLoadExperienceModifyEffects(actionsDep, experiencesService, storeDep);
};

export const JobsiteLoadSalesAreasFactory = (injector: Injector) => {
  const modifyStoreDep = injector.get(Store<ModifyOrderState>);
  const actionsDep = injector.get(Actions);
  const jobsiteLoaderService = injector.get(JobsiteLoaderService);
  const productLoaderService = injector.get(ProductLoaderService);

  return new JobsiteLoadSalesAreasEffects(modifyStoreDep, actionsDep, jobsiteLoaderService, productLoaderService);
};

export const PurchaseOrderMaskModifyFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const purchaseOrderService = injector.get(PurchaseOrderService);
  return new PurchaseOrderMaskModifyEffects(actionsDep, purchaseOrderService);
};

export const SimulateFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const alerts = injector.get(CmxClientService);
  const ordersService = injector.get(OrdersService);
  const translate = injector.get(TranslateService);
  const rmsOrderRequestSolverService = injector.get(RmsOrderRequestSolverService);
  const modifyStore = injector.get(Store<OrderBuilderState>);

  return new SimulateEffects(actionsDep, alerts, ordersService, translate, rmsOrderRequestSolverService, modifyStore);
};

export const PointOfDeliveryLoadFactory = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const shipmentLocationService = injector.get(ShipmentLocationsService);
  const http = injector.get(CmxHttpClient);
  const addressService = injector.get(AddressService);
  const analyticsTrackingService = injector.get(AnalyticsTrackingService);
  const featureToggleService = injector.get(FeatureToggleService);
  return new PointOfDeliveryLoadEffects(
    storeDep,
    actionsDep,
    shipmentLocationService,
    http,
    addressService,
    analyticsTrackingService,
    featureToggleService,
  );
};

export const PointOfDeliveryLoadAddressFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const addressesService = injector.get(AddressesService);
  const opportunityService = injector.get(OpportunityService);

  return new PointOfDeliveryLoadAddressEffects(actionsDep, addressesService, opportunityService);
};

export const ReceivingPersonsCustomerLoadFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const contactService = injector.get(ContactService);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const featureToggleService = injector.get(FeatureToggleService);
  const effectRegistrationService = injector.get(EffectsRegistrationService);

  return new ReceivingPersonsCustomerLoadEffects(
    actionsDep,
    contactService,
    storeDep,
    featureToggleService,
    effectRegistrationService,
  );
};

export const JobsitePlantFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const plantsService = injector.get(PlantsService);
  const alerts = injector.get(CmxClientService);
  const translate = injector.get(TranslateService);
  const effectRegistrationService = injector.get(EffectsRegistrationService);

  return new JobsitePlantEffects(actionsDep, plantsService, alerts, translate, effectRegistrationService);
};

export const JobsitePlantDefaultFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const plantsService = injector.get(PlantsService);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const effectRegistrationService = injector.get(EffectsRegistrationService);

  return new JobsitePlantDefaultEffects(actionsDep, plantsService, storeDep, effectRegistrationService);
};

export const PurchaseOrderRMSMandatoryFactory = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storePo = injector.get(Store<PurchaseOrderState>);
  const purchaseOrderService = injector.get(PurchaseOrderService);
  const effectRegistrationService = injector.get(EffectsRegistrationService);

  return new PurchaseOrderRMSMandatoryEffects(actionsDep, storePo, purchaseOrderService, effectRegistrationService);
};

export const OneClickJobsitesFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const stdLotSizeService = injector.get(StdLotSizeService);
  const jobsiteSalesAreasService = injector.get(JobsiteSalesAreasService);
  const jobsiteCommercialChannelService = injector.get(JobsiteCommercialChannelService);

  return new OneClickJobsitesEffects(
    actionsDep,
    storeDep,
    stdLotSizeService,
    jobsiteSalesAreasService,
    jobsiteCommercialChannelService,
  );
};

export const OneClickProfileFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const draftService = injector.get(DraftService);
  const ordersService = injector.get(OrdersService);
  const alertService = injector.get(CmxClientService);
  const translate = injector.get(TranslateService);
  const oneClickDraftService = injector.get(OneClickDraftService);

  return new OneClickProfileEffects(
    actionsDep,
    storeDep,
    draftService,
    ordersService,
    alertService,
    translate,
    oneClickDraftService,
  );
};

export const OneClickBuilderPaymentsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const paymentTermService = injector.get(PaymentTermService);

  return new OneClickBuilderPaymentsEffects(actionsDep, storeDep, paymentTermService);
};

export const OneClickPlantsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const plantsService = injector.get(PlantsService);

  return new OneClickPlantsEffects(actionsDep, storeDep, plantsService);
};

export const OneClickPointOfDeliveriesFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const destinationsService = injector.get(DestinationsService);
  const http = injector.get(CmxHttpClient);

  return new OneClickPointOfDeliveriesEffects(actionsDep, storeDep, destinationsService, http);
};

export const OneClickRegionPlantsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const plantsService = injector.get(PlantsService);

  return new OneClickRegionPlantsEffects(actionsDep, storeDep, plantsService);
};

export const OneCLickAlternativeUnitsBuilderFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const productService = injector.get(ProductService);

  return new OneCLickAlternativeUnitsBuilderEffects(actionsDep, storeDep, productService);
};

export const OneClickPaymentsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OneClickOrderState>);
  const paymentTermService = injector.get(PaymentTermService);

  return new OneClickPaymentsEffects(actionsDep, storeDep, paymentTermService);
};

export const OneClickTimeWindowsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const timeWindowsService = injector.get(TimeWindowsService);

  return new OneClickTimeWindowsEffects(actionsDep, timeWindowsService);
};

export const OneClickStandardLotFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const stdLotSizeService = injector.get(StdLotSizeService);
  const storeDep = injector.get(Store<LayoutState>);

  return new OneClickStandardLotEffects(actionsDep, stdLotSizeService, storeDep);
};

export const OneClickReceivingPersonFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const contactService = injector.get(ContactService);

  return new OneClickReceivingPersonEffects(actionsDep, contactService);
};

export const OneClickContractFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OneClickOrderState>);
  const actionsDep = injector.get(Actions);
  const http = injector.get(CmxHttpClient);

  return new OneClickContractEffects(storeDep, actionsDep, http);
};

export const OneClickJobsiteSalesAreaFromOrderFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const jobsiteSalesAreasService = injector.get(JobsiteSalesAreasService);

  return new OneClickJobsiteSalesAreaFromOrderEffects(actionsDep, jobsiteSalesAreasService);
};

export const OneClickAdditionalServicesFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const productService = injector.get(ProductService);

  return new OneClickAdditionalServicesEffects(actionsDep, productService);
};

export const OneClickHaulersFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const haulersService = injector.get(HaulersService);

  return new OneClickHaulersEffects(actionsDep, haulersService);
};

export const OneClickOwnFreightPlantsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const plantsService = injector.get(PlantsService);

  return new OneClickOwnFreightPlantsEffects(actionsDep, plantsService);
};

export const OneClickHolidaysFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const holidaysService = injector.get(HolidaysService);

  return new OneClickHolidaysEffects(actionsDep, holidaysService);
};

export const OneClickNextWorkingDayFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const nextWorkingDayService = injector.get(NextWorkingDayService);

  return new OneClickNextWorkingDayEffects(actionsDep, nextWorkingDayService);
};

export const OneCLickAlternativeUnitsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const productService = injector.get(ProductService);

  return new OneCLickAlternativeUnitsEffects(actionsDep, productService);
};

export const OneClickSalesAreaErrorFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const translate = injector.get(TranslateService);
  const alertService = injector.get(CmxClientService);

  return new OneClickSalesAreaErrorEffects(actionsDep, translate, alertService);
};

export const AnticipatedInvoiceLoadFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const salesDocumentService = injector.get(SalesDocumentManagementService);

  return new AnticipatedInvoiceLoadEffects(storeDep, actionsDep, salesDocumentService);
};

export const NewReceivingPersonFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const http = injector.get(CmxHttpClient);
  const contactPersonApi = injector.get(ContactPersonApiService);
  const alertService = injector.get(CmxClientService);
  const translate = injector.get(TranslateService);
  const contactService = injector.get(ContactService);
  const featureToggleService = injector.get(FeatureToggleService);

  return new NewReceivingPersonEffects(
    actionsDep,
    storeDep,
    http,
    contactPersonApi,
    alertService,
    translate,
    contactService,
    featureToggleService,
  );
};

export const JobsiteLoadLocSpecFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const jobsiteLoaderService = injector.get(JobsiteLoaderService);
  const productLoaderService = injector.get(ProductLoaderService);
  const blockedJobsiteLoaderService = injector.get(JobsiteBlockedService);

  return new JobsiteLoadLocSpecEffects(
    storeDep,
    actionsDep,
    jobsiteLoaderService,
    productLoaderService,
    blockedJobsiteLoaderService,
  );
};

export const ProductLoadLocSpecFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const productsApi = injector.get(ProductsOpenPlatformService);

  return new ProductLoadLocSpecEffects(storeDep, actionsDep, productsApi);
};

export const ProductExperienceLoadFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const productsApi = injector.get(ProductsOpenPlatformService);
  const productServices = injector.get(ProductService);

  return new ProductExperienceLoadEffects(storeDep, actionsDep, productsApi, productServices);
};

export const JobsiteLoadExperienceFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const experiencesServices = injector.get(ExperiencesService);
  const storeDep = injector.get(Store<OrderBuilderState>);

  return new JobsiteLoadExperienceEffects(actionsDep, experiencesServices, storeDep);
};

export const JobsiteLoadExperienceCompleteFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);

  return new JobsiteLoadExperienceCompleteEffects(actionsDep, storeDep);
};

export const PODLoadFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const shipmentLocationsService = injector.get(ShipmentLocationsService);

  return new PODLoadEffects(storeDep, actionsDep, shipmentLocationsService);
};

export const TimeWindowsFromPlantLocationSpecificationFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const timeWindowsService = injector.get(TimeWindowsService);
  const plantsService = injector.get(PlantsService);

  return new TimeWindowsFromPlantLocationSpecificationEffects(actionsDep, storeDep, timeWindowsService, plantsService);
};

export const AddedValuesOpenPlatformFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const technicalProductsOpenPlatformService = injector.get(TechnicalProductsOpenPlatformService);

  return new AddedValuesOpenPlatformEffects(actionsDep, storeDep, technicalProductsOpenPlatformService);
};

export const SimulateOPFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const alerts = injector.get(CmxClientService);
  const ordersService = injector.get(OrdersService);
  const translate = injector.get(TranslateService);
  const rmsULOrderRequestSolverService = injector.get(ULOrderRequestSolverService);
  const storeDep = injector.get(Store<OrderBuilderState>);

  return new SimulateOPEffects(actionsDep, alerts, ordersService, translate, rmsULOrderRequestSolverService, storeDep);
};

export const LoadHolidaysFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const holidaysStoreDep = injector.get(Store<HolidaysState>);
  const holidaysService = injector.get(HolidaysService);

  return new LoadHolidaysEffect(actionsDep, storeDep, holidaysStoreDep, holidaysService);
};

export const PaymentTermsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const paymentTermService = injector.get(PaymentTermService);

  return new PaymentTermsEffects(actionsDep, storeDep, paymentTermService);
};

export const MinLotFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const stdLotSizeService = injector.get(StdLotSizeService);

  return new MinLotEffects(actionsDep, stdLotSizeService);
};

export const TopProductsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const productService = injector.get(ProductService);

  return new TopProductsEffects(actionsDep, storeDep, productService);
};

export const TopProductsULinkFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const productsOpenPlatformService = injector.get(ProductsOpenPlatformService);
  const featureToggleService = injector.get(FeatureToggleService);
  const productService = injector.get(ProductService);

  return new TopProductsULinkEffects(
    actionsDep,
    storeDep,
    productsOpenPlatformService,
    featureToggleService,
    productService,
  );
};

export const V1OfmNextWorkingDayFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const featureToggleService = injector.get(FeatureToggleService);
  const nextWorkingDayService = injector.get(NextWorkingDayService);

  return new V1OfmNextWorkingDayEffects(actionsDep, storeDep, featureToggleService, nextWorkingDayService);
};

export const ProductPlantsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const plantsService = injector.get(PlantsService);

  return new ProductPlantsEffects(actionsDep, plantsService);
};

export const VehiclesFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const vehiclesService = injector.get(VehiclesService);

  return new VehiclesEffects(actionsDep, storeDep, vehiclesService);
};

export const TimeWindowsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const timeWindowsService = injector.get(TimeWindowsService);
  const effectsRegistrationService = injector.get(EffectsRegistrationService);

  return new TimeWindowsEffects(actionsDep, storeDep, timeWindowsService, effectsRegistrationService);
};

export const TimeWindowsFromPlantFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const timeWindowsService = injector.get(TimeWindowsService);
  const plantsService = injector.get(PlantsService);
  const effectsRegistrationService = injector.get(EffectsRegistrationService);

  return new TimeWindowsFromPlantEffects(
    actionsDep,
    storeDep,
    timeWindowsService,
    plantsService,
    effectsRegistrationService,
  );
};

export const NextWorkingDayFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const nextWorkingDayService = injector.get(NextWorkingDayService);

  return new NextWorkingDayEffect(actionsDep, storeDep, nextWorkingDayService);
};

export const ContractBalanceFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const httpDep = injector.get(CmxHttpClient);

  return new ContractBalanceEffects(actionsDep, storeDep, httpDep);
};

export const ContractFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const httpDep = injector.get(CmxHttpClient);
  const paymentTermsService = injector.get(PaymentTermService);

  return new ContractEffects(actionsDep, storeDep, httpDep, paymentTermsService);
};

export const AlternativeUnitsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const productService = injector.get(ProductService);
  const effectsRegistrationService = injector.get(EffectsRegistrationService);

  return new AlternativeUnitsEffects(actionsDep, productService, effectsRegistrationService);
};

export const UnitsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const productService = injector.get(ProductService);
  const effectsRegistrationService = injector.get(EffectsRegistrationService);

  return new UnitsEffects(actionsDep, storeDep, productService, effectsRegistrationService);
};

export const ExperiencesLoadFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const experiencesService = injector.get(ExperiencesService);
  const httpDep = injector.get(CmxHttpClient);

  return new ExperiencesLoadEffect(actionsDep, storeDep, httpDep, experiencesService);
};

export const JobsiteNoShippingConditionLoadFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const shipmentLocationsService = injector.get(ShipmentLocationsService);

  return new JobsiteNoShippingConditionLoadEffects(storeDep, actionsDep, shipmentLocationsService);
};

export const JobsiteWithoutDocumentsLoadFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const shipmentLocationsService = injector.get(ShipmentLocationsService);

  return new JobsiteWithoutDocumentsLoadEffects(storeDep, actionsDep, shipmentLocationsService);
};

export const JobsiteLoadSalesAreaWithoutPlantFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const jobsiteSalesAreasService = injector.get(JobsiteSalesAreasService);
  const storeDep = injector.get(Store<OrderBuilderState>);

  return new JobsiteLoadSalesAreaWithoutPlantEffects(actionsDep, jobsiteSalesAreasService, storeDep);
};

export const JobsiteStdLotFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const stdLotSizeService = injector.get(StdLotSizeService);

  return new JobsiteStdLotEffects(actionsDep, stdLotSizeService);
};

export const CalendarsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const calendarsService = injector.get(CalendarsService);
  const rmsExperience = injector.get(ExperiencesServiceInternal);

  return new CalendarsEffects(actionsDep, storeDep, calendarsService, rmsExperience);
};

export const JobsiteLoadFullSalesAreaFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const httpDep = injector.get(CmxHttpClient);
  const rmsExperience = injector.get(ExperiencesServiceInternal);

  return new JobsiteLoadFullSalesAreaEffects(actionsDep, httpDep, rmsExperience);
};

export const PointOfDeliveryLoadAddressNewPODFactory: factoryEffectFn = (injector: Injector) => {
  const storeDep = injector.get(Store<OrderBuilderState>);
  const actionsDep = injector.get(Actions);
  const addressesService = injector.get(AddressesService);
  const opportunityService = injector.get(OpportunityService);
  const shipmentLocationsService = injector.get(ShipmentLocationsService);

  return new PointOfDeliveryLoadAddressNewPODEffects(
    storeDep,
    actionsDep,
    addressesService,
    opportunityService,
    shipmentLocationsService,
  );
};

export const PointOfDeliveryRenderMapFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const effectRegister = injector.get(EffectsRegistrationService);

  return new PointOfDeliveryRenderMapEffects(actionsDep, effectRegister);
};

export const PointOfDeliveryRadiusRenderMapFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const effectRegister = injector.get(EffectsRegistrationService);

  return new PointOfDeliveryRadiusRenderMapEffects(actionsDep, storeDep, effectRegister);
};

export const PointOfDeliveryLoadSalesAreaFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const pointOfDeliverySalesAreasService = injector.get(PointOfDeliverySalesAreasService);

  return new PointOfDeliveryLoadSalesAreaEffects(storeDep, actionsDep, pointOfDeliverySalesAreasService);
};

export const PurchaseOrderMandatoryFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const purchaseOrderService = injector.get(PurchaseOrderService);
  const effectRegister = injector.get(EffectsRegistrationService);

  return new PurchaseOrderMandatoryEffects(actionsDep, storeDep, purchaseOrderService, effectRegister);
};

export const AdtProductsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const productsOpenPlatformService = injector.get(ProductsOpenPlatformService);

  return new AdtProductsEffects(actionsDep, productsOpenPlatformService);
};

export const AdtContractsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const contractBalanceService = injector.get(ContractBalanceService);

  return new AdtContractsEffects(actionsDep, contractBalanceService);
};

export const AdtUnitsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const productService = injector.get(ProductService);

  return new AdtUnitsEffects(actionsDep, productService);
};

export const AdtPaymentTermsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const paymentTermService = injector.get(PaymentTermService);
  const storeDep = injector.get(Store<OrderBuilderState>);

  return new AdtPaymentTermsEffects(actionsDep, paymentTermService, storeDep);
};

export const RmsColombiaProductsFactory: factoryEffectFn = (injector: Injector) => {
  const actionsDep = injector.get(Actions);
  const storeDep = injector.get(Store<OrderBuilderState>);
  const productService = injector.get(ProductService);

  return new RmsColombiaProductsEffects(actionsDep, storeDep, productService);
};
